import { Tooltip, Typography } from 'antd';
import { IEllipsisTextProps } from './EllipsisText.types';

import './EllipsisText.styles.scss';

const { Paragraph } = Typography;

const EllipsisText = ({ style, children, fontSize = '12px', ...props }: IEllipsisTextProps) => {
  return (
    <Tooltip title={children}>
      <Paragraph ellipsis style={{ fontSize, ...style }} className="np-ellipsis-text" {...props}>
        {children}
      </Paragraph>
    </Tooltip>
  );
};

export default EllipsisText;
